import { connect } from "react-redux";

import AppOnboardingWrapper from "./AppOnboardingWrapper";
import {
  completeAppOnboardingStep,
  skipAppOnboardingStep,
  fetchAppOnboarding,
  pollAppOnboardingProgress,
  showCompletionModal,
  hideCompletionModal,
  updateDiscountModalShown,
} from "./appOnboardingActions";

const mapStateToProps = state => ({
  appOnboardingState: state.appOnboarding,
});

const mapDispatchToProps = {
  fetchAppOnboarding,
  pollAppOnboardingProgress,
  completeAppOnboardingStep,
  skipAppOnboardingStep,
  showCompletionModal,
  hideCompletionModal,
  updateDiscountModalShown,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppOnboardingWrapper);
